<template>
  <div
    ref="productFamilyFacet"
    :class="{
      'product-family-head-facet-fi': true,
      'product-family-head-facet-fi--disabled': facet.disabled,
    }"
  >
    <div class="product-family-head-facet-fi__name">
      {{ factFinderNgNameCleaner(facet.name) }}
    </div>
    <div
      :class="{
        'product-family-head-facet-fi__wrapper': true,
        'product-family-head-facet-fi__wrapper--expanded': isExpanded || !isExpandable,
        'product-family-head-facet-fi__wrapper--expandable': isExpandable,
      }"
      :style="{
        gridTemplateRows: `${maxHeight}px ${isExpanded ? 1 : 0}fr`,
      }"
    >
      <div class="product-family-head-facet-fi__wrapper__inner">
        <div
          ref="expanderContent"
          class="product-family-head-facet-fi__options"
        >
          <div
            v-for="option in facet.elements"
            :key="option.associatedFieldName"
            :class="{
              'product-family-head-facet-fi__option': true,
              'product-family-head-facet-fi__option--selected': isEffectivelySelected(option),
              'product-family-head-facet-fi__option--disabled':
                option.disabled && !option.selectedImplicit,
            }"
            @click="onFacetClicked(option)"
          >
            <!-- keep the label in an element: a translator replaces a bare text node and Vue then patches a detached node -->
            <span>{{ option.text }}</span> <span v-if="facet.unit">&nbsp;{{ facet.unit }}</span>

            <icon-fi
              v-if="isEffectivelySelected(option)"
              class="product-family-head-facet-fi__option__icon"
              icon="close"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isExpandable"
        class="product-family-head-facet-fi__expand"
      >
        <div
          class="product-family-head-facet-fi__expand__text"
          @click="isExpanded = !isExpanded"
        >
          {{
            isExpanded
              ? $dict.get('product-Family.Facets.Show-Less')
              : $dict.get('product-Family.Facets.Show-More')
          }}
          <icon-fi
            icon="chevron-down"
            :class="{
              'product-family-head-facet-fi__expand__icon': true,
              'product-family-head-facet-fi__expand__icon--expanded': isExpanded,
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';
import { onMounted, ref, useTemplateRef } from 'vue';

import factFinderNgNameCleaner from '@/components/search-fact-finder-fi/factFinderNgNameCleaner';

defineOptions({
  name: 'ProductFamilyHeadFacetFi',
});

const maxHeight = 108;

defineProps<{
  facet: any;
}>();

const emits = defineEmits<{
  'change-facet': [value: any];
}>();

const expanderContent = useTemplateRef('expanderContent');

const isExpandable = ref(false);
const isExpanded = ref(false);

onMounted(() => {
  if (IS_SSR) {
    return;
  }

  if (expanderContent.value?.clientHeight && expanderContent.value?.clientHeight > maxHeight) {
    isExpandable.value = true;
  }
});

const unselectedImplicits = ref(new Set<string>());

const isEffectivelySelected = (option: any) => {
  return (
    option.selected ||
    (option.selectedImplicit && !unselectedImplicits.value.has(option.associatedFieldName))
  );
};

const onFacetClicked = (option: any) => {
  if (option.selectedImplicit) {
    const set = unselectedImplicits.value;
    if (set.has(option.associatedFieldName)) {
      set.delete(option.associatedFieldName);
    } else {
      set.add(option.associatedFieldName);
    }
    unselectedImplicits.value = new Set(set);
    return;
  }

  emits('change-facet', option);
};
</script>

<style scoped src="./product-family-head-facet-fi" />
